import {Model} from 'vue-mc';
import moment from 'moment'
// Validation rules
import {
    boolean,
    equal,
    integer,
    min,
    required,
    string,
    length,
    email
} from 'vue-mc/validation'


/**
 * Contact model
 */
export default class SearchBookingModel extends Model {


    // Default attributes that define the "empty" state.
    defaults() {
        return {
            refNum: "",
            location: "",
            language: "",
            interpreter: "",
            calds: "",
            requestedBy: "",
            jobType: "",
            clockOnStatus: "",
            serviceDate: "",
            startServiceDate: moment(),
            endServiceDate: null,
            startServiceDateFormatted: "",
            endServiceDateFormatted: "",
            statusFilterValue: "",
            search: "",
            job_slip_file_name: "",
        }
    }

    options() {
        return {
            validateOnChange: true,
            validateOnSave: true,
            validateRecursively: true,
        }
    }

    // Route configuration
    routes() {
        return {
            fetch: "job/test"
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/searchBookingModel.js